import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    template: require('./bs-card-menu.html')
})
export class BSCardMenu extends Vue {
    @Prop({ type: String, required: false })
    image?: string;

    @Prop({ type: String, required: false })
    icon?: string;

    @Prop(String)
    title!: string;

    @Prop(String)
    description!: string;

    @Prop(Function)
    action!: Function;

    @Prop(String)
    buttonText!: string;

    @Prop(String)
    cardClass!: string;

    @Prop(String)
    tooltip!: string;

    @Prop(String)
    btnClass!: string;
}
